import moment from 'moment'
import React from 'react'
import { Button, Card, Col, Drawer, Form, Icon, notification, Row, Table, Select, Upload, Tabs } from 'antd'
import _ from 'lodash'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request, { API_URL, LAPI_URL } from '../../request'
import { connect } from 'react-redux'

const Option = Select.Option

@Form.create()
class InboxRenewalMail extends React.Component {
    state = {
        visible: true,
        loading: false,
        templateArr: [],
    }

    loadSmsTemplate = async () => {
        let templateArr = await Request.getTemplatesForCommunication('Email');
        this.setState({ templateArr })
    }

    getAllDetails = async () => {
        let { universityId } = this.props;
        let response = await Request.getUniversity(universityId);
        let user = localStorage.getItem('user') != 'undefined'
            ? JSON.parse(localStorage.getItem('user'))
            : null
        this.props.form.setFieldsValue({ emailFrom: user.email, emailTo: response.doc.contactEmailThree, universityId: universityId })
    }


    async componentDidMount() {
        this.loadSmsTemplate()
        this.getAllDetails()
    }

    onClose = () => {
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }


    handleSubmit = e => {
        e.preventDefault();
        const { form, courseId, data } = this.props;
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);
                let response = await Request.sendAgreementRenewalMail(values)
                if (!response.error) {
                    notification.success({
                        message: 'Mail sent successfully'
                    });
                    this.onClose();
                } else {
                    notification.error({
                        message: response.msg,
                    })
                }
            }

        })
    }

    render() {

        const {
            form: { getFieldDecorator, getFieldValue }
        } = this.props
        const { templateArr } = this.state

        const inputTypes = {
            fields: [
                {
                    label: '',
                    key: 'universityId',
                    type: 'hidden',
                },
                {
                    label: 'From',
                    key: 'emailFrom',
                    required: true
                },
                {
                    label: 'To',
                    key: 'emailTo',
                    required: true
                },
                {
                    label: 'CC',
                    key: 'toCC',
                    required: true
                },
                {
                    label: 'Reply To',
                    key: 'replyTo',
                },
                {
                    label: 'Subject',
                    key: 'subject',
                    required: true
                },
                {
                    label: 'Choose Template',
                    key: 'templateId',
                    type: 'select',
                    showSearch: true,
                    required: true,
                    allowClear: true,
                    width: 500,
                    keyAccessor: x => x.templateData,
                    valueAccessor: x => x.templateName,
                    disabled: false,
                    options: templateArr ? templateArr : {},
                    onChange: v => {
                        this.props.form.setFieldsValue({ templateId: v })
                        this.props.form.setFieldsValue({ template: v })
                    }
                },
                {
                    label: 'Template',
                    key: 'template',
                    required: true,
                    type: 'editor',
                    rows: 15
                }
            ]
        }

        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Send Renewal Mail
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={this.state.visible}>
                <Card>
                    <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                        <div>
                            <GetAllFormFields
                                apiurl={LAPI_URL}
                                inputSchema={inputTypes}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InboxRenewalMail)
